import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredRole?: 'super_admin' | 'client_admin' | 'org_admin' | 'org_member';
}
export const ProtectedRoute = ({
  children,
  requiredRole
}: ProtectedRouteProps) => {
  const {
    user,
    isAuthenticated
  } = useAuth();
  const location = useLocation();
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{
      from: location
    }} replace data-id="element-268" />;
  }
  if (requiredRole && user?.role.type !== requiredRole) {
    // If user is super_admin, send them to admin dashboard
    if (user?.role.type === 'super_admin') {
      return <Navigate to="/admin/clients" replace data-id="element-269" />;
    }
    // Otherwise send them to regular dashboard
    return <Navigate to="/dashboard" replace data-id="element-270" />;
  }
  return <>{children}</>;
};